import * as React from 'react';
import checkmark from '../../../../assets/images/static_pages/green_checkmark.svg';

interface ColumnFeaturesProps {
  featureSections: Record<string, any>;
}

export const ColumnFeatures = ({ featureSections }: ColumnFeaturesProps) => {
  const sections = featureSections.map((section, idx) => {
    const features = section.features.map((feature) => {
      const [show, setShow] = React.useState(false);
      const handleMouseEnter = () => setShow(true);
      const handleMouseLeave = () => setShow(false);
      const hoverStateClass = `hover-state ${show ? '' : 'hide'}`;
      return (
        <tr key={feature.body + idx}>
          <td className="symbol">
            <img className="complete" src={checkmark} alt="checkmark" />
          </td>
          <td>
            <span className={section.bold ? 'bold' : ''}>{feature.body}</span>
            {
              feature.hover && (
                <>
                  &nbsp;
                  <span
                    className="orange info-icon"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    ⓘ
                  </span>
                  <span className={hoverStateClass}>
                    <span className="bold-600">{feature.hover.header}</span>
                    <br />
                    <p>{feature.hover.body}</p>
                  </span>
                </>
              )
            }
          </td>
        </tr>
      );
    });

    return (
      <div className="mb-10" key={section.header}>
        <p className="fsz-12 mb-5 bold-600" style={section.style}>{section.header}</p>
        <table>
          <tbody>{features}</tbody>
        </table>
      </div>
    );
  });

  return <>{sections}</>;
};
